import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
import { Button, Form, Input } from 'antd';

import { type LoginPayload, useLoginValidation, login } from 'api';
import { message } from 'antd';
//import { style } from '../Login';

// import { AUTH_ROUTES } from '../../routes';
import {
  KeyOutlined,
  LockOutlined,
  UserOutlined,
  ReloadOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';

import { useState, useRef, useEffect } from 'react'; // Import useState
// import Anchor from 'antd/lib/anchor/Anchor';
// import { Link } from 'react-router-dom';
// State to control OTP input visibility and whether OTP has been sent
type SizeType = Parameters<typeof Form>[0]['size'];
type Props = {
  onSubmit: (values: LoginPayload) => void;
  isLoading: boolean;
};

const OTP_RESEND_COOLDOWN_SECONDS = 180; // 3 minutes


// 1. Create a helper function OUTSIDE the component or inside useMemo
// const getOrGenerateClientId = () => {
//   let storedId = localStorage.getItem('clientId');
//   console.log('storedId 1', storedId);
//   if (!storedId) {
//     // Fallback if crypto.randomUUID is not supported (e.g. non-secure context)
//     if (typeof crypto !== 'undefined' && crypto.randomUUID) {
//       storedId = crypto.randomUUID();
//       console.log('if storedClientId', storedId);
//     } else {
//       storedId = `client-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
//       console.log('else storedClientId', storedId);
//     }
//     localStorage.setItem('clientId', storedId);
//   }
//   return storedId;
// };

const setCookie = (name: string, value: string, days: number) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
};

const getCookie = (name: string) => {
  return document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1] || '') : r;
  }, '');
};

const getOrGenerateClientId = (): string => {
  // 1. Try LocalStorage
  try {
    const localId = localStorage.getItem('clientId');
    if (localId) return localId;
  } catch (e) { /* Ignore */ }

  // 2. Try Cookie (The Backup)
  const cookieId = getCookie('clientId');
  console.log("cookieId:", cookieId);
  if (cookieId) return cookieId;

  // 3. Generate New
  const newId = (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : `client-${Date.now()}`;

  // 4. Save to both (Best Effort)
  try { localStorage.setItem('clientId', newId); } catch (e) { /* Ignore */ }
  setCookie('clientId', newId, 7); // Save for 7 days

  return newId;
};
const Login = ({ onSubmit, isLoading }: Props) => {
  // --- NEW STATES FOR TIMER AND RESEND ---
  const [otpTimer, setOtpTimer] = useState(0); // Countdown in seconds
  const [showResendButton, setShowResendButton] = useState(false);
  const timerIntervalRef = useRef<NodeJS.Timeout | null>(null); // To store interval ID for cleanup
  const [isResendingOtp, setIsResendingOtp] = useState(false);
  const [areCredentialsDisabled, setAreCredentialsDisabled] = useState(false);
  //const [clientId, setClientId] = useState<string | null>(null); // State to store the client ID
  const [otpExpirationTimestamp, setOtpExpirationTimestamp] = useState(0);
  const [clientId] = useState<string>(getOrGenerateClientId);

  const { t } = useTranslation();
  const [form] = Form.useForm();
  const validation = useLoginValidation();
  if (showResendButton === true) {
    validation.otp = [{ required: false, message: 'do not OTP!' }];
  }

  useEffect(() => {
    let storedClientIdLocalStorage = localStorage.getItem('clientId');
    console.log('useEffect storedClientId', storedClientIdLocalStorage);

    // if (!storedClientIdLocalStorage) {
    //   // Generate a new UUID if not found
    //   storedClientIdLocalStorage = crypto.randomUUID();
    //   localStorage.setItem('clientId', storedClientIdLocalStorage);
    //   console.log('Generated new clientId:', storedClientIdLocalStorage);
    // } else {
    //   console.log('Retrieved existing clientId:', storedClientIdLocalStorage);
    // }
    // setClientId(storedClientIdLocalStorage);
  }, []); // Run only once on component mount

  console.log('Login');
  const handleLogin = async (values: LoginPayload) => {
    if (!clientId) {
      message.error('Client ID is not available. Please refresh the page.');
      return;
    }

    values.otpAction = 'VALIDATE_OTP';
    values.clientId = clientId as string;
    values.tokenId = sessionStorage.getItem('token') || ''
    console.log('----Inside the handleLogin-----' + values);
    const data = await onSubmit(values);
    console.log('----Inside the handleLogin data-----' + data);
    //setOtpSent(false);
  };

  const [isGeneratingOtp, setIsGeneratingOtp] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const handleGenerateOtp = async () => {
    if (!clientId) {
      message.error('Client ID is not available. Please refresh the page.');
      return;
    }
    try {
      const actionType = 'GENERATE_OTP';
      const { username, password, otp } = await form.validateFields([
        'username',
        'password',
        'otp',
      ]);
      const otpGenerationPayload = {
        username,
        password,
        otp: otp, // Include the action type if your OTP generation API expects it
        otpAction: actionType,
        clientId: clientId as string, // Include the client ID here
        tokenId: sessionStorage.getItem('token') || '',
      };
      console.log('Attempting to generate OTP with payload:', otpGenerationPayload);
      setIsGeneratingOtp(true); // --- SET LOADING TRUE FOR OTP GENERATION ---
      // --- FIX: Ensure timer is set when generation starts ---
      //setOtpTimer(OTP_RESEND_COOLDOWN_SECONDS); // Reset timer immediately

      setShowResendButton(false); // Hide resend button immediately
      console.log('handle resend otp', showResendButton, isResendingOtp, isGeneratingOtp);

      try {
        const data = await login(otpGenerationPayload); // Call your backend API
        setOtpTimer(OTP_RESEND_COOLDOWN_SECONDS); // Reset timer immediately
        if (data && data.status === 'SUCCESS') {

          if (data.data && data.data.jwtToken) {
            console.log("data.data.jwtToken", data.data.jwtToken);
            sessionStorage.setItem('token', data.data.jwtToken);
            console.log("sessionStorage.getItem token", sessionStorage.getItem("token"));
          }
          // Check for explicit 'SUCCESS' status
          // --- BEGIN: NEW LOGIC FOR isMFAEnabled ---
          if (!data.data.isMFAEnabled) {
            console.log(
              'MFA is disabled. Directly logging in. data.data.isMFAEnabled',
              data.data.isMFAEnabled
            );
            // Create the login payload and call the onSubmit function directly.
            const directLoginPayload: LoginPayload = {
              username,
              password,
              otpAction: 'FINAL_LOGIN', // Or whatever action type your direct login requires
              otp: '',
              clientId: clientId as string,
              tokenId: data.data.jwtToken || sessionStorage.getItem('token') as string || '',
            };
            onSubmit(directLoginPayload); // Call the main onSubmit to complete login
            return; // Exit the function to prevent further OTP logic
          }
          // --- END: NEW LOGIC ---
          console.log('OTP generation successful:', data.message);
          console.log('New Token Saved:', sessionStorage.getItem('token'));
          setAreCredentialsDisabled(true);
          setOtpSent(true); // Set to true only on success
          message.success(data.message); // Display success message to the user
          const expirationTime = Date.now() + OTP_RESEND_COOLDOWN_SECONDS * 1000;
          setOtpExpirationTimestamp(expirationTime);
        } else if (data && data.status === 'ERROR') {
          // Check for explicit 'ERROR' status
          console.error('OTP generation failed........:', data.message);
          setOtpSent(false); // Set to false if backend indicates failure
          setAreCredentialsDisabled(false);
          //message.error(data.message); // Display error message to the user
        } else {
          // Fallback for unexpected response structure
          console.error('OTP generation failed: Unknown response format or status...');
          setOtpSent(false);
          setAreCredentialsDisabled(false);
          message.error('An unexpected error occurred. Please try again.');
        }
      } catch (backendError: any) {
        // Added type annotation for backendError
        console.error('Error during OTP generation API call:', backendError.message);
        setOtpSent(false); // Set to false on any backend/network error
        setAreCredentialsDisabled(false);
        message.error(`Failed to generate OTP===: ${backendError.message}`); // Display generic network/API error
      } finally {
        setIsGeneratingOtp(false); // --- RESET LOADING FALSE FOR OTP GENERATION ---
        setIsResendingOtp(false);
      }
    } catch (errorInfo) {
      console.log('Validation Failed:', errorInfo);
      setIsGeneratingOtp(false); // Reset loading on validation failure
      setIsResendingOtp(false); // Ensure resending state is reset
      setOtpSent(false);
    }
  };

  // Helper to format time for display (MM:SS)
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  // --- useEffect for OTP Timer ---
  // useEffect(() => {
  //   if (otpSent && otpTimer > 0) {
  //     // Start or continue timer only if OTP is sent and timer is not zero
  //     timerIntervalRef.current = setInterval(() => {
  //       setOtpTimer((prev) => {
  //         if (prev <= 1) {
  //           // Timer reached 0 or less
  //           clearInterval(timerIntervalRef.current as NodeJS.Timeout);
  //           timerIntervalRef.current = null;
  //           setShowResendButton(true); // Enable resend button
  //           return 0;
  //         }
  //         return prev - 1;
  //       });
  //     }, 1000);
  //   } else if (!otpSent && timerIntervalRef.current) {
  //     // If OTP is no longer sent, clear any running timer
  //     clearInterval(timerIntervalRef.current);
  //     timerIntervalRef.current = null;
  //     setOtpTimer(0);
  //     setShowResendButton(true);
  //   }

  useEffect(() => {
    let timerId: NodeJS.Timeout | null = null;

    // Only run the timer if the OTP has been sent and we have an expiration time
    if (otpSent && otpExpirationTimestamp > 0) {
      // Set the initial timer value immediately
      const initialRemainingTime = Math.max(
        0,
        Math.floor((otpExpirationTimestamp - Date.now()) / 1000)
      );
      setOtpTimer(initialRemainingTime);
      setShowResendButton(initialRemainingTime <= 0);

      // Start a new interval to update the timer every second
      timerId = setInterval(() => {
        const remainingTime = Math.max(0, Math.floor((otpExpirationTimestamp - Date.now()) / 1000));
        setOtpTimer(remainingTime);

        if (remainingTime <= 0) {
          clearInterval(timerId as NodeJS.Timeout);
          setShowResendButton(true);
        }
      }, 1000);
    }

    // Cleanup function: Clear interval if component unmounts or dependencies change
    return () => {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
      }
    };
  }, [otpSent, otpExpirationTimestamp]); // Dependency array: run when otpSent or otpTimer changes

  // --- NEW: handleResendOtp function ---
  // const handleResendOtp = async () => {
  //   setShowResendButton(true);
  //   setIsResendingOtp(true); // Set state to indicate resending
  //   setOtpTimer(0);
  //   console.log('handle resend otp', showResendButton, isResendingOtp, isGeneratingOtp)

  //   await handleGenerateOtp(); // Call the core generation logic
  //   console.log('handle resend otp', showResendButton, isResendingOtp, isGeneratingOtp)
  // };
  return (
    <>
      <div className="container">
        <div className="col-xs-12 col-sm-6 col-md-6 offset-md-3 offset-sm-3" id="user_logged_out">
          <div
            className="submission-box"
            style={{
              width: '100%',
              float: 'right',
              background: 'white',
              marginTop: '-38px',
              borderRadius: '5px',
              marginBottom: '2px',
              marginLeft: '25%',
            }}
          >
            <h2>Login Form</h2>
            <div className="submission-form login-box">
              <div className="login-erro-msg"></div>

              <Form<LoginPayload>
                form={form}
                onFinish={handleLogin}
                scrollToFirstError
                layout="horizontal"
                size={'large' as SizeType}
              >
                <Form.Item name="username" rules={validation.username}>
                  <Input
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    autoFocus
                    disabled={areCredentialsDisabled}
                    placeholder={t('logIn.email.placeholder')}
                  />
                </Form.Item>
                <Form.Item name="password" rules={validation.password} validateFirst>
                  <Input
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    type="password"
                    placeholder="Password"
                    disabled={areCredentialsDisabled}
                    className="ant-input-lg"
                  />
                </Form.Item>
                <Form.Item>
                  {/*  
                   <Anchor style={{ float: 'right', marginBottom: '30px' }}>
                    <Link to="/auth/forgotten-password">Forgot Password?</Link>
                   </Anchor> 
                  */}
                  <span style={{ color: 'red' }}>
                    Note: For Forgot Password Please Contact System Admin.
                  </span>
                </Form.Item>

                {/* <Button block type="primary" htmlType="submit" loading={isLoading}>
                  {t('logIn.generateOTP')}
                </Button>
                <br></br>
                <Form.Item name="otp" rules={validation.otp} validateFirst>
                  <Input
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    type="otp"
                    placeholder="Enter 6 digit OTP"
                    className="ant-input-lg"
                  />
                </Form.Item> */}
                {/* <Button block type="primary" htmlType="submit" loading={isLoading}>
                  {t('logIn.submit')}
                </Button> */}

                {!otpSent && !showResendButton ? (
                  // <Button block type="primary" onClick={handleGenerateOtp} loading={isLoading}>
                  //   Generate OTP
                  // </Button>
                  // <Button block type="primary" onClick={handleGenerateOtp} loading={isLoading}>
                  //   {t('logIn.generateOTP')}
                  // </Button>
                  // <Button block type="primary" onClick={handleGenerateOtp} loading={isGeneratingOtp}>
                  //   {t('logIn.generateOTP')}
                  // </Button>
                  <Button
                    block
                    type="primary"
                    onClick={handleGenerateOtp}
                    loading={isGeneratingOtp} // Ant Design's loading spinner
                    disabled={isGeneratingOtp} // Disable interactions while loading
                    className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 mb-4
                               bg-blue-500 text-white"
                  >
                    {/* {isGeneratingOtp ? 'Generating...' : t('logIn.generateOTP')} */}
                    {/* {isGeneratingOtp ? 'Generating...' : 'Generate OTP'} */}
                    {isGeneratingOtp ? 'Authenticate...' : 'Authenticate'}
                  </Button>
                ) : (
                  <>
                    <Form.Item name="otp" rules={validation.otp} validateFirst>
                      <Input
                        prefix={<KeyOutlined className="site-form-item-icon" />}
                        type="text"
                        placeholder="Enter your 6-character code"
                        className="ant-input-lg"
                        maxLength={6}
                        // --- START: PREVENT COPY/PASTE/CUT ---
                        // onCopy={(e) => e.preventDefault()}
                        // onPaste={(e) => e.preventDefault()}
                        // onCut={(e) => e.preventDefault()}
                        // // Optionally, prevent drag and drop as well
                        // onDrag={(e) => e.preventDefault()}
                        // onDrop={(e) => e.preventDefault()}
                        // --- END: PREVENT COPY/PASTE/CUT ---
                      />
                    </Form.Item>

                    {/* --- NEW: OTP Timer Display --- */}
                    <div className="flex justify-between items-center mb-4">
                      <span className="text-gray-600 text-sm flex items-center">
                        <ClockCircleOutlined className="mr-1" /> OTP valid for:
                        <span className="ml-1 font-bold text-blue-700">
                          {' '}
                          {formatTime(otpTimer)}
                        </span>
                      </span>

                      {/* --- NEW: Resend OTP Button (Conditionally rendered) --- */}
                      {/* {(showResendButton && !isGeneratingOtp) && (
                        <Button
                          type="link"
                          onClick={handleResendOtp}
                          loading={isResendingOtp}
                          // disabled={isResendingOtp || otpTimer > 0}
                          className="text-blue-500 hover:text-blue-700"
                        >
                          <ReloadOutlined className="mr-1" />
                          {isGeneratingOtp ? 'Resending...' : 'Resend OTP'}
                        </Button>
                      )} */}
                      <Button
                        type="link"
                        onClick={handleGenerateOtp} // Call handleGenerateOtp directly for resend
                        loading={isGeneratingOtp} // Use isGeneratingOtp for loading spinner
                        disabled={isGeneratingOtp || otpTimer > 0} // Disabled if generating OR timer is active
                        className="text-blue-500 hover:text-blue-700 disabled:text-gray-400 disabled:cursor-not-allowed"
                      >
                        <ReloadOutlined className="mr-1" />
                        {isGeneratingOtp ? 'Resending...' : 'Resend Otp'} {/* Dynamic text */}
                      </Button>
                    </div>
                    {/* --- END NEW --- */}

                    <Button block type="primary" htmlType="submit" loading={isLoading}>
                      {t('logIn.submit')}
                    </Button>
                  </>
                )}
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
